import { render } from "./ConsentBanner.vue?vue&type=template&id=10ad8305"
import script from "./ConsentBanner.vue?vue&type=script&lang=js"
export * from "./ConsentBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__